// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AsinInputController from "./asin_input_controller"
application.register("asin-input", AsinInputController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BlogArticleController from "./blog_article_controller"
application.register("blog-article", BlogArticleController)

import BlogEditorController from "./blog_editor_controller"
application.register("blog-editor", BlogEditorController)

import CalculatorController from "./calculator_controller"
application.register("calculator", CalculatorController)

import CalendarRangeController from "./calendar_range_controller"
application.register("calendar-range", CalendarRangeController)

import CogsMarketplacesController from "./cogs_marketplaces_controller"
application.register("cogs-marketplaces", CogsMarketplacesController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DeleteConfirmController from "./delete_confirm_controller"
application.register("delete-confirm", DeleteConfirmController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import DurationCompareController from "./duration_compare_controller"
application.register("duration-compare", DurationCompareController)

import EstimatorLoadingController from "./estimator_loading_controller"
application.register("estimator-loading", EstimatorLoadingController)

import ExpenseFormController from "./expense_form_controller"
application.register("expense-form", ExpenseFormController)

import ExtensionStatusController from "./extension_status_controller"
application.register("extension-status", ExtensionStatusController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import FilterListController from "./filter_list_controller"
application.register("filter-list", FilterListController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FloatingCtaController from "./floating_cta_controller"
application.register("floating-cta", FloatingCtaController)

import GroupWizardController from "./group_wizard_controller"
application.register("group-wizard", GroupWizardController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HeroDotsController from "./hero_dots_controller"
application.register("hero-dots", HeroDotsController)

import IndexCheckFormController from "./index_check_form_controller"
application.register("index-check-form", IndexCheckFormController)

import IndexCheckPollerController from "./index_check_poller_controller"
application.register("index-check-poller", IndexCheckPollerController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import KeywordInputController from "./keyword_input_controller"
application.register("keyword-input", KeywordInputController)

import KeywordSuggestionsController from "./keyword_suggestions_controller"
application.register("keyword-suggestions", KeywordSuggestionsController)

import KeywordTableController from "./keyword_table_controller"
application.register("keyword-table", KeywordTableController)

import LimitCounterController from "./limit_counter_controller"
application.register("limit-counter", LimitCounterController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiPickerController from "./multi_picker_controller"
application.register("multi-picker", MultiPickerController)

import OffcanvasController from "./offcanvas_controller"
application.register("offcanvas", OffcanvasController)

import PaddleCheckoutController from "./paddle_checkout_controller"
application.register("paddle-checkout", PaddleCheckoutController)

import PeriodFilterController from "./period_filter_controller"
application.register("period-filter", PeriodFilterController)

import PnlPreviewController from "./pnl_preview_controller"
application.register("pnl-preview", PnlPreviewController)

import PopupCalendarRangeController from "./popup_calendar_range_controller"
application.register("popup-calendar-range", PopupCalendarRangeController)

import PpcChartController from "./ppc_chart_controller"
application.register("ppc-chart", PpcChartController)

import PpcColumnsController from "./ppc_columns_controller"
application.register("ppc-columns", PpcColumnsController)

import PpcDrawerController from "./ppc_drawer_controller"
application.register("ppc-drawer", PpcDrawerController)

import PpcSearchController from "./ppc_search_controller"
application.register("ppc-search", PpcSearchController)

import PpcToggleController from "./ppc_toggle_controller"
application.register("ppc-toggle", PpcToggleController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import ProductFilterController from "./product_filter_controller"
application.register("product-filter", ProductFilterController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SiteHeaderController from "./site_header_controller"
application.register("site-header", SiteHeaderController)

import SkuPickerController from "./sku_picker_controller"
application.register("sku-picker", SkuPickerController)

import SkuTableController from "./sku_table_controller"
application.register("sku-table", SkuTableController)

import SortController from "./sort_controller"
application.register("sort", SortController)

import SparklineController from "./sparkline_controller"
application.register("sparkline", SparklineController)

import StatementFiltersController from "./statement_filters_controller"
application.register("statement-filters", StatementFiltersController)

import StatementTableController from "./statement_table_controller"
application.register("statement-table", StatementTableController)

import StickyColumnsController from "./sticky_columns_controller"
application.register("sticky-columns", StickyColumnsController)

import TocCollapseController from "./toc_collapse_controller"
application.register("toc-collapse", TocCollapseController)

import TurboFramePollerController from "./turbo_frame_poller_controller"
application.register("turbo-frame-poller", TurboFramePollerController)
